import { QUERY_fetchOrderBidders } from 'queries';
import { createApolloCache, createApolloClient } from 'providers/ApolloProvider';
import { FetchOrderBiddersQuery } from 'types/graphql';

const requestAwardTeamClient = createApolloClient({ cache: createApolloCache() });

export type AwardTeamMemberOrder = Extract<
  NonNullable<FetchOrderBiddersQuery['node']>,
  { __typename: 'Order' }
>;

export type AwardTeamMemberConflictedShift =
  AwardTeamMemberOrder['bids'][number]['conflictedShifts'][number];

export type AwardTeamMemberData = { order: AwardTeamMemberOrder };

export const requestAwardTeamConfig = ({ orderId }: { orderId: string }) => ({
  key: 'FETCH_ORDER_BIDDERS',
  query: QUERY_fetchOrderBidders,
  client: requestAwardTeamClient,
  responseTransformer: (rawData: FetchOrderBiddersQuery): AwardTeamMemberData => {
    const node = rawData?.node;
    if (node?.__typename !== 'Order') return null as unknown as AwardTeamMemberData;
    return { order: node };
  },
  schema: {
    orderId: {
      initialValue: orderId,
    },
    byMultipleFields: {
      initialValue: '',
    },
    byEmploymentStatus: {
      initialValue: [],
    },
  },
});
